const WISHLIST_ITEM_TPL = $('#wishlistItemTemplate').html();
const WISHLIST_REMOVAL_TPL = $('#wishlistRemovalTemplate').html();

Hop.defineModule('wishlist-list-container', (root) => {
    const $root = $(root);

    function WishlistContainer($container) {
        this.init($container);
    }

    WishlistContainer.prototype = {
        init: function ($container) {
            this.container = $container;
            this.wishlistCreationModal = $('#wishlistCreationModal');
            this.wishlistRemovalModal = $('#wishlistRemovalModal');
            this.wishlistCreationForm = $('#wishlistCreationForm');
            this.newWishlistDomTarget = this.container.find('#newWishlistTarget');

            this.setHandlers();
        },

        resetForm: function (form) {
            form[0].reset();
        },

        redirectToWishlist: function (wishlistUrl) {
            const newUrl = new Url(wishlistUrl);

            window.location.href = newUrl;
        },

        createNewWishlist: function () {
            const self = this;

            function addNewWishlistItem(wishlist) {
                const itemSettings = {
                    wishlistUrl: wishlist.url,
                    wishlistName: wishlist.name,
                    wishlistId: wishlist.id,
                    profileCount: wishlist.profiles.length,
                    profileCountMessage: Hop.icuMessage('wishlist.list.freelancers.count', {
                        nbFreelancers: wishlist.profiles.length,
                    }),
                    itemWidth: self.container.find('[data-wishlistId]').length ? self.container.find('[data-wishlistId]')[0].clientWidth : '',
                };

                const html = Hop.template(WISHLIST_ITEM_TPL, {variable: 'm'})(itemSettings);

                self.newWishlistDomTarget.before(html);
                self.wishlistCreationModal.modal('hide');
            }

            const newWishlistName = self.wishlistCreationForm.find('input').val();
            Hop.wishlists.createWishlist({
                wishlistName: newWishlistName,
                callback: addNewWishlistItem,
            });
        },

        showWishlistRemovalModal: function (tag) {
            const wishlistToDeleteId = tag.attr('data-wishlistToDeleteId');
            const wishlistToDeleteName = tag.attr('data-wishlistToDeleteName');
            const wishlistToDeleteProfileCount = tag.attr('data-wishlistToDeleteProfileCount');

            function generateModalContent() {
                const removalSettings = {
                    wishlistName: wishlistToDeleteName,
                    wishlistId: wishlistToDeleteId,
                    profileCountMessage: Hop.icuMessage('wishlist.list.freelancers.count', {
                        nbFreelancers: wishlistToDeleteProfileCount,
                    }),
                };

                const html = Hop.template(WISHLIST_REMOVAL_TPL, {variable: 'm'})(removalSettings);
                $('#wishlistRemovalContent').html(html);
            }

            generateModalContent();
            this.wishlistRemovalModal.modal('show');
        },

        deleteWishlist: function (wishlistId) {
            const self = this;

            function deleteWishlistItem(wishlistId) {
                const itemToDelete = self.container.find('[data-wishlistId="' + wishlistId + '"]');
                itemToDelete.remove();
                self.wishlistRemovalModal.modal('hide');
            }

            Hop.wishlists.deleteWishlist({
                wishlistId: wishlistId,
                callback: function () {
                    return deleteWishlistItem(wishlistId);
                },
            });
        },

        setHandlers: function () {
            this.wishlistCreationForm.on('submit', (e) => {
                e.preventDefault();
                this.createNewWishlist();
            });

            this.container.on('click', '.wishlistRemoval', (e) => {
                const tag = $(e.target).closest('.wishlistRemoval');
                this.showWishlistRemovalModal(tag);
            });

            this.wishlistRemovalModal.on('click', '#wishlistDeleteConfirm', (e) => {
                e.preventDefault();
                const wishlistToDeleteId = $(e.target).attr('data-wishlistToDeleteId');
                this.deleteWishlist(wishlistToDeleteId);
            });

            this.wishlistCreationModal.on('hidden.bs.modal', () => {
                this.resetForm(this.wishlistCreationForm);
            });

            this.container.on('click', '[data-wishlistUrl]', (e) => {
                if (!$(e.target).closest('.wishlistRemoval').length) {
                    // test if user didn't cicked on remove wishlist cta
                    const targetedWishlistUrl = $(e.target).closest('[data-wishlistUrl]').attr('data-wishlistUrl');
                    this.redirectToWishlist(targetedWishlistUrl);
                }
            });
        },
    };

    new WishlistContainer($root.find('#wishlistContainer'));
});
